import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as types from '../../constants/ActionTypes';
import { IS_APP_CODEAC } from '../../constants/env';
import Layout from '../../containers/Layout';
import Icon from '../../components/Icon';
import RepositoryDetailDrawer from '../../components/RepositoryDetailDrawer';
import Badge from './components/Badge';
import { CodeCoverage } from './components/CodeCoverage';
import Tokens from './components/Tokens';
import ErrorPageContent from '../../components/ErrorPageContent';
import { getRepositoryFullnameFromMatch } from '../../utils/getRepository';
import { HANDLED_ERRORS } from '../../constants/types';
import { getVcsIdBySlug } from '../../constants/api';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
import { replaceAsciiCharWithSlash } from '../../utils/resolveBranch';
import { VcsSettings } from './components/VcsSettings';
class RepositorySettingsPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loaded: false,
            loadTimeout: null,
        };
        this.handleUpdateTokens = (tokens) => {
            const { repository, dispatch } = this.props;
            repository.setTokens(tokens);
            dispatch({
                type: types.UPDATE_REPOSITORY,
                payload: { repository },
            });
        };
        this.loadRepository = async (fullname) => {
            const { match, repository, dispatch } = this.props;
            if (!repository) {
                const repositoryFullname = fullname ?? replaceAsciiCharWithSlash(getRepositoryFullnameFromMatch(match));
                const vcs = getVcsIdBySlug(match.params.vcs);
                try {
                    const dashboardResponse = await this.context.getDashboard(vcs, repositoryFullname);
                    if (dashboardResponse.repository) {
                        await dispatch({
                            type: types.ADD_REPOSITORY,
                            payload: dashboardResponse,
                        });
                        const activeBranch = match.params.branch ? dashboardResponse.repository.getBranchByName(match.params.branch) : dashboardResponse.repository.getMainBranch();
                        await dispatch({
                            type: types.UPDATE_ACTIVE_BRANCH,
                            payload: { repositoryId: dashboardResponse.repository.id, activeBranch },
                        });
                        this.setState({
                            loaded: true,
                        });
                    }
                    else {
                        this.setState({ loaded: true });
                    }
                }
                catch (error) {
                    const statusCode = error.networkError?.statusCode;
                    if (HANDLED_ERRORS.includes(statusCode)) {
                        this.setState({
                            loaded: true,
                        });
                    }
                    else {
                        throw error;
                    }
                }
            }
            else {
                this.setState({
                    loaded: true,
                });
            }
        };
    }
    async componentDidMount() {
        await this.loadRepository();
    }
    componentWillUnmount() {
        if (this.state.loadTimeout) {
            clearTimeout(this.state.loadTimeout);
        }
    }
    render() {
        const { user, match, repository, activeBranches, t } = this.props;
        const { loaded } = this.state;
        if (loaded && !repository) {
            // @ts-expect-error TS2741: Property 'code' is missing in type
            return _jsx(ErrorPageContent, { ...this.props });
        }
        if (!repository) {
            return null;
        }
        const repositoryFullname = replaceAsciiCharWithSlash(getRepositoryFullnameFromMatch(match)); // @ToDo it's necessary here?
        const activeBranch = activeBranches ? activeBranches[repository.id] : null;
        const { titlePrimary, titleSecondary } = repository.getTitleParts();
        const branch = activeBranch ?? repository.getMainBranch();
        const lastCommit = branch?.getLastCommit();
        return (_jsx(Layout, { title: t('settings.settings') + ' - ' + titlePrimary, loginRequired: true, match: match, titlePrimary: titlePrimary, titleSecondary: titleSecondary, children: repository &&
                _jsx("div", { className: "container repository-detail__container", children: _jsxs("div", { className: "row", children: [_jsx(RepositoryDetailDrawer, { vcsSlug: match.params.vcs, fullName: repositoryFullname, className: "col col-12 col-md-2", isUserLoggedIn: user.loggedIn }), _jsxs("div", { className: "col col-12 col-md-10 repository-detail__content", children: [_jsx("div", { className: "d-flex flex-column flex-md-row", children: _jsx("div", { className: "col-12 col-md-8 col-lg-10 p-0", children: !IS_APP_CODEAC && (_jsxs(_Fragment, { children: [_jsx("div", { className: "repository-detail__owner", children: titleSecondary }), _jsx("h2", { className: "repository-detail__title", children: titlePrimary })] })) }) }), _jsxs("div", { className: "report-detail__items mt-1 container", "data-testid": "repository-settings", children: [_jsx("h4", { children: t('settings.settings') }), !loaded ? (_jsxs("div", { className: "text-center", children: [_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "2x" }), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] })) : (_jsxs("div", { children: [_jsx(Badge, { repository: repository, lastCommit: lastCommit }), _jsx("div", { className: "mt-5" }), _jsx(Tokens, { repositoryId: repository.id, tokens: repository.tokens, onUpdateTokens: this.handleUpdateTokens }), _jsx("div", { className: "mt-5" }), _jsx(CodeCoverage, { tokens: repository.tokens }), _jsx("div", { className: "mt-5" }), _jsx(VcsSettings, { repository: repository })] }))] })] })] }) }) }));
    }
}
RepositorySettingsPage.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    repositories: state.repositories,
    user: state.user,
    repository: state.repository.repository,
    activeBranches: state.activeBranches,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RepositorySettingsPage));
